/* yoclay-cache-bust 20260904133839 */
/**
 * YoClay Pocket — carrinho.
 * - Add to cart AJAX no order bump (carrinho com kit)
 * - Impede checkout só com pockets avulsos (redireciona para Kit Salva Tédio)
 */
(function () {
  if (typeof window === 'undefined') return;

  var KIT_SALVA_TEDIO_URL = '/products/kit-salva-tedio';
  var PETS_SLUGS = {
    tony: 1, guga: 1, chico: 1, maia: 1, cleo: 1, tobias: 1,
    goldi: 1, nina: 1, simba: 1, mel: 1, zeca: 1, pipoca: 1
  };

  function isPocketHandle(handle) {
    if (!handle) return false;
    return (
      handle.indexOf('yoclay-pocket-moldar') !== -1 ||
      handle.indexOf('yoclay-pocket-para-moldar') !== -1 ||
      handle.indexOf('yoclay-pocket-botanico') !== -1 ||
      handle.indexOf('yoclay-pocket-natal-') !== -1
    );
  }

  function isPetsPocketHandle(handle) {
    if (!handle) return false;
    var prefix = 'yoclay-pocket-moldar-';
    if (handle.indexOf(prefix) !== 0) return false;
    var slug = handle.slice(prefix.length);
    return !!PETS_SLUGS[slug];
  }

  function packUrlForHandle(handle) {
    if (handle && handle.indexOf('yoclay-pocket-natal-') !== -1) {
      return '/products/yoclay-pockets-edicao-limitada-de-natal';
    }
    if (isPetsPocketHandle(handle)) {
      return '/products/pockets-pets';
    }
    if (handle && handle.indexOf('yoclay-pocket-botanico') !== -1) {
      return '/products/pockets-botanicos';
    }
    return KIT_SALVA_TEDIO_URL;
  }

  function cartHasNonPocketLine() {
    var lines = document.querySelectorAll('[data-section-type="cart"] [data-yoclay-cart-line-handle]');
    for (var i = 0; i < lines.length; i++) {
      var handle = lines[i].getAttribute('data-yoclay-cart-line-handle') || '';
      if (!isPocketHandle(handle)) return true;
    }
    return false;
  }

  function cartHasPackAssemblyLine() {
    var lines = document.querySelectorAll('[data-section-type="cart"] [data-yoclay-cart-line-handle]');
    for (var i = 0; i < lines.length; i++) {
      if (lines[i].getAttribute('data-yoclay-pack-line') === 'true') return true;
    }
    return false;
  }

  function pocketOnlyCart() {
    var lines = document.querySelectorAll('[data-section-type="cart"] [data-yoclay-cart-line-handle]');
    if (!lines.length) return false;
    if (cartHasPackAssemblyLine()) return false;
    return !cartHasNonPocketLine();
  }

  function showPocketOnlyMessage() {
    var lines = document.querySelectorAll('[data-section-type="cart"] [data-yoclay-cart-line-handle]');
    var firstHandle = lines.length ? lines[0].getAttribute('data-yoclay-cart-line-handle') || '' : '';
    var target = packUrlForHandle(firstHandle);
    var msg =
      target.indexOf('yoclay-pockets-edicao-limitada-de-natal') !== -1
        ? 'Os Pockets de Natal avulsos só podem ser comprados montando o pack. Vamos te levar para montar o seu.'
        : target.indexOf('pockets-pets') !== -1
        ? 'Os Pockets Pets avulsos só podem ser comprados montando o pack. Vamos te levar para montar o seu.'
        : target.indexOf('pockets-botanicos') !== -1
        ? 'Os Pockets Botânicos avulsos só podem ser comprados montando o pack. Vamos te levar para montar o seu.'
        : 'Os Pockets avulsos só podem ser comprados montando um Kit Salva Tédio. Vamos te levar para montar o seu pack.';
    window.alert(msg);
    window.location.assign(target);
  }

  function bindCheckoutGuard() {
    document.addEventListener(
      'click',
      function (e) {
        if (!pocketOnlyCart()) return;
        var target = e.target.closest(
          '[name="checkout"], .cart-submit, .ymp_check_mainBtn, a[href*="/checkout"]'
        );
        if (!target) return;
        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === 'function') {
          e.stopImmediatePropagation();
        }
        showPocketOnlyMessage();
        return false;
      },
      true
    );
  }

  function setButtonLoading(btn, loading) {
    if (!btn) return;
    var isIconButton = btn.classList.contains('yoclay-product-card__button');
    if (loading) {
      btn.setAttribute('aria-busy', 'true');
      btn.setAttribute('disabled', 'disabled');
      if (isIconButton) {
        if (!btn.dataset.yoclayPrevAriaLabel) {
          btn.dataset.yoclayPrevAriaLabel = btn.getAttribute('aria-label') || '';
        }
        btn.setAttribute(
          'aria-label',
          (window.theme && window.theme.strings && window.theme.strings.addingToCart) || 'Adicionando…'
        );
      } else {
        if (!btn.dataset.yoclayPrevLabel) {
          btn.dataset.yoclayPrevLabel = btn.textContent;
        }
        btn.textContent =
          (window.theme && window.theme.strings && window.theme.strings.addingToCart) || 'Adicionando…';
      }
    } else {
      btn.removeAttribute('aria-busy');
      btn.removeAttribute('disabled');
      if (isIconButton) {
        if (btn.dataset.yoclayPrevAriaLabel) {
          btn.setAttribute('aria-label', btn.dataset.yoclayPrevAriaLabel);
        }
      } else if (btn.dataset.yoclayPrevLabel) {
        btn.textContent = btn.dataset.yoclayPrevLabel;
      }
    }
  }

  function refreshCartPage() {
    window.location.assign(
      (window.theme && window.theme.routes && window.theme.routes.cart_url) || '/cart'
    );
  }

  function bindCartUpsellAdd() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-yoclay-pocket-cart-add]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();

      var variantId = parseInt(btn.getAttribute('data-variant-id'), 10);
      if (!variantId) return;

      setButtonLoading(btn, true);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: 1,
              properties: {
                _yoclay_order_bump: 'Pocket extra (carrinho)'
              }
            }
          ]
        })
      })
        .then(function (res) {
          if (!res.ok) {
            return res.json().then(function (err) {
              throw err;
            });
          }
          return res.json();
        })
        .then(function () {
          if (btn.classList.contains('yoclay-product-card__button')) {
            if (btn.dataset.yoclayPrevAriaLabel) {
              btn.setAttribute(
                'aria-label',
                (window.theme && window.theme.strings && window.theme.strings.addedToCart) ||
                  'Adicionado'
              );
            }
          } else if (btn.dataset.yoclayPrevLabel) {
            btn.textContent =
              (window.theme && window.theme.strings && window.theme.strings.addedToCart) ||
              'Adicionado';
          }
          setTimeout(refreshCartPage, 400);
        })
        .catch(function () {
          setButtonLoading(btn, false);
          window.alert(
            'Não foi possível adicionar este Pocket. Tente novamente ou atualize a página do carrinho.'
          );
        });
    });
  }

  function init() {
    if (!document.body.classList.contains('template-cart')) return;
    bindCartUpsellAdd();
    bindCheckoutGuard();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
